import { GenericCrudPage } from '@/components/GenericCrudPage';
import { couponsConfig } from '@/pages/configs';

export default function CouponsPage() {
  return <GenericCrudPage config={couponsConfig} />;
}
